export default "__VITE_ASSET__5cbbda0b__"